<template>
  <div class="by-code-table-header-actions">
    <el-popover placement="bottom-end" width="420" trigger="click" title="How these are calculated">
      <div class="calculation-definitions">
        <div v-for="item in definitions" :key="item.label" class="calculation-definitions__item">
          <strong>{{ item.label }}</strong>
          <p v-for="(paragraph, index) in item.paragraphs" :key="index" v-html="paragraph"></p>
        </div>
      </div>
      <el-button type="text" slot="reference" class="calculation-help-link" title="How these are calculated">
        <i class="el-icon-info"></i>
      </el-button>
    </el-popover>
    <slot />
  </div>
</template>

<script>
  const DEFINITIONS = [
    {
      label: 'Totals',
      paragraphs: [
        'These totals may differ from the main accuracy reports, such as By Coder, By Provider or By Service Line. Those reports score the record as a whole; this report counts each unique code individually.',
        'For revisions, the original code is counted as Revised From and the replacement code is counted as Revised To.'
      ]
    },
    {
      label: 'Accuracy',
      paragraphs: [
        'Accuracy is based on No Change, Deletion and Revised From counts. Additions and Revised To are not included.',
        'A code that appears only as an Addition or Revised To does not have an accuracy rate.'
      ]
    },
    {
      label: '% of All Missed Opportunities',
      paragraphs: [
        'For each code, this is its <strong>Additions + Revised To</strong> divided by the total Additions + Revised To for the table.',
        'These percentages add up to 100%.'
      ]
    }
  ]

  export default {
    name: 'ByCodeCalculationsHelp',
    data() {
      return {
        definitions: DEFINITIONS
      }
    }
  }
</script>

<style scoped>
  .by-code-table-header-actions {
    position: relative;
    z-index: 3;
    float: right;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 20px;
    margin: 0 0 -10px 0;
    line-height: 20px;
  }

  .calculation-help-link {
    padding: 0;
    height: 20px;
    border: 0;
    line-height: 20px;
    color: #606266;
    font-size: 14px;
  }

  .calculation-definitions__item {
    margin-bottom: 12px;
  }

  .calculation-definitions__item:last-child {
    margin-bottom: 0;
  }

  .calculation-definitions__item p {
    margin: 4px 0 0;
    color: #606266;
    line-height: 1.5;
  }

  .calculation-definitions__item p + p {
    margin-top: 12px;
  }

  .calculation-definitions__item >>> strong {
    color: #303133;
  }
</style>
